// Angular
import { Component } from '@angular/core';
import { Router } from '@angular/router';

// Ionic
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  ModalController,
  IonButton,
  IonButtons,
  IonIcon
} from '@ionic/angular/standalone';

@Component({
  selector: 'amwager3-show-message-to-verifiy-documents',
  templateUrl: './show-message-to-verifiy-documents.component.html',
  styleUrls: ['./show-message-to-verifiy-documents.component.scss'],
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonButton,
    IonIcon
  ]
})
export class ShowMessageToVerifiyDocumentsComponent {

  constructor(private modalCtrl: ModalController, private router: Router) {}

  goTo(url: string): void {
    this.router.navigate([url]);
    this.dismissModal();
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }

}
